import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Overlay from '../../Miscelania/Overlay';

import { Modal } from 'react-bootstrap';

class BaseYearPeriodDaysReformModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      modal: false,
      loaded: 0,
      mis_days: '',
      fr_days: '',
      date: '',
      id: '',
    };
    //Handlers
    this.reformDays = this.reformDays.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  //LM
  componentWillReceiveProps(newProps) {
    if (newProps.modal_props === true) {
      this.setState({
        id: newProps.data_period_modal.id,
        modal: true,
        mis_days: newProps.data_period_modal.mis_days,
        fr_days: newProps.data_period_modal.fr_days,
        date_start: newProps.date_day_modal,
        loaded: 1,
      });
    } else {
      this.setState({
        modal: false,
      });
    }
  }

  reformDays(event) {
    event.preventDefault();
    var confirm = window.confirm('Deseja reaplicar a regra a partir desta data?');
    if (confirm) {
      this.setState({ modal: false });

      var datasave = {
        base_year_period_id: this.state.id,
        date_start: this.state.date_start,
        mis_days: this.state.mis_days,
        fr_days: this.state.fr_days,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      self.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/base/ano/periodo/datas/reformular', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }  
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <Modal show={self.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">Edição a partir de {self.state.date_start}</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>self.props.modalPropsOff()}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={self.reformDays}>
              <div className="row">
                <div className="col-md-6 form-group">
                  <label>Dias de missão:</label>
                  <input type="number" className="form-control" name="mis_days" value={self.state.mis_days} placeholder="" onChange={self.handleChange.bind(self, 'mis_days')} />
                </div>
                <div className="col-md-6 form-group">
                  <label>Dias de folga:</label>
                  <input type="number" className="form-control" name="fr_days" value={self.state.fr_days} placeholder="" onChange={self.handleChange.bind(self, 'fr_days')} />
                </div>
              </div>
              <button type={'submit'} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Reformular período</button>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>self.props.modalPropsOff()}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default BaseYearPeriodDaysReformModal;



// WEBPACK FOOTER //
// ./src/Components/Bases/Elements/BaseYearPeriodDaysReformModal.js